import React from 'react';
import TranscriptUploader from '../../components/reusable/TranscriptUploader';
import {
  CloudArrowUpIcon,
  DocumentTextIcon,
  ClockIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';
import { LoginForm } from '../login/LoginForm';
import { useAuth } from '../../hooks/useAuth';

export default function TranscriptUpload() {
  const { user, loading, error, getAuth } = useAuth();

  if (!user) {
    return (
      <LoginForm 
        onSSOLogin={getAuth}
        ssoLoading={loading}
        ssoError={error}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">
      {/* Header Section */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <div className="p-3 bg-purple-100 rounded-full mr-4">
                <CloudArrowUpIcon className="h-12 w-12 text-purple-600" />
              </div>
              <h1 className="text-4xl font-bold text-gray-900">
                Upload Transcript
              </h1>
            </div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Upload and process new transcript files, audio recordings, or other materials. 
              Our system will automatically transcribe and analyze your content.
            </p>
          </div>
        </div>
      </div>

      {/* Main Upload Area */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-4">
            <h2 className="text-xl font-bold text-white flex items-center">
              <ClockIcon className="h-6 w-6 mr-2" />
              Upload New Content
            </h2>
          </div>
          
          <div className="p-6">
            <TranscriptUploader />
          </div>
        </div>

      </div>
    </div>
  );
}